/*
 * Copyright ©2020. Open Digital Solutions, Novi Sad. Sva prava zadržana.
 * Pravo da se koristi, kopira, modifikuje i distribuira ovaj softver i njegova dokumentacija
 * u bilo koje svrhe, bez naknade ili bez potpisanog sporazuma sa vlasnikom softvera, nije dozvoljeno.
 */

import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from 'src/app/local-storage.service';
import { ArchiveSubjectComponent } from 'src/app/subjects/subject-details/archive-subject/archive-subject.component';
import { DialogActions } from 'src/app/utils/DialogActionsArchive';
import { formatDate } from 'src/app/utils/formatDate';
import { CaseService } from 'src/services/case.service';
import { CpsuCasesService } from 'src/services/cpsu-cases.service';
import { CpsuSubjectService } from 'src/services/cpsu-subject.service';
import { DataSharingService } from 'src/services/data-sharing.service';
import { ToastrImplService } from 'src/services/toastr.service';
import { TranslatorService } from 'src/services/translator.service';
import { UserService } from 'src/services/user.service';
import { ModalSizeEnum } from 'src/types';

@Component({
   selector: 'app-cpsu-subject-details',
   templateUrl: './cpsu-subject-details.component.html',
   styleUrls: ['./cpsu-subject-details.component.scss'],
})
export class CpsuSubjectDetailsComponent implements OnInit {
   showDivider = false;
   minFromDate = new Date();
   loggedIn: any;
   isSubjectHistoryRendered: Boolean = false;
   isMainCenterBelgrade = false;
   isUserDrugostepeni = false;
   editUserDetailsText = '';
   editUsertDetailTextError = '';
   localStorageCenterId: any;
   isAdmin: boolean = false;
   cpsuId: any;
   fosterFamilyData: any[] = []
   constructor(
      private route: ActivatedRoute,
      private translate: TranslateService,
      private translatorService: TranslatorService,
      public dialog: MatDialog,
      private dataSharingService: DataSharingService,
      private localStorageService: LocalStorageService,
      private caseService: CaseService,
      private toastr: ToastrImplService,
      private userService: UserService,
      private cpsuSubjectService: CpsuSubjectService,
      private cpsuCaseService: CpsuCasesService
   ) {
      this.getNationalities();
      this.localStorageCenterId = this.localStorageService.get('localStorageCenterId');
      this.loggedIn = JSON.parse(this.localStorageService.get('loggedUser'));
      this.isMainCenterBelgrade = this.loggedIn?.csrId === '1' ? true : false;
      this.isUserDrugostepeni = this.userService.isUserDrugostepeni();
      this.isAdmin = this.userService.isGlobalAdmin();

      this.route.params.subscribe(params => {
         this.cpsuId = params.id;
         this.getCurrentCpsuSubject(this.cpsuId);
      });

      this.translate.get('SUBJECT_DETAILS.DOSSIER_CHANGE_TOOLTIP').subscribe((resp: string) => {
         this.editUserDetailsText = resp;
      });

      this.translate.get('SUBJECT_DETAILS.ARHIVED_DOSSIER_CHANGE_TOOLTIP').subscribe((resp: string) => {
         this.editUsertDetailTextError = resp;
      });
   }

   selectTab(tab: any) {
      if (tab.index === 2) {
         this.isSubjectHistoryRendered = true;
      }
   }
   isDossierAssignedToViewer: boolean;
   isArchived: boolean;
   isArchivedInCsr: boolean;
   isEditMode = false;
   subject: any;
   nationality = [];
   businessAbility: string;
   category = []; // category of person for nationality
   subjectCategory: string;
   familyDossier: any;
   familyType: any;
   date = ['', '', ''];
   gender: boolean;
   jmbg: any;
   object: any = {
      subject: '',
      action: '',
      isCpsuUser: true,
      subjectFullName: ''
   };
   registrationId = null;

   ngOnInit(): void {}

   getCurrentCpsuSubject(cpsuId: any) {
      this.cpsuSubjectService.getCurrentCpsuSubject(cpsuId).subscribe(res => {
         this.subject = res;
         if (this.subject.dateOfBirth !== null) {
            this.subject.dateOfBirth = this.subject.dateOfBirth.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$1.$2.$3.');
         }
         this.subject.dateOfModification = this.subject.dateOfModification.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$1.$2.$3.');
         this.subject.dateOfCreation = this.subject.dateOfCreation.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$1.$2.$3.');
         this.registrationId = res.registrationId;
         this.subjectCategory = res?.category?.title;

         if (this.subject?.disabledPerson || this.subject?.disabilityType || this.subject?.occupation || this.subject?.employment || this.subject?.education || this.subject?.maritalStatus) {
            this.showDivider = true;
         }

         if (res.familyDossier === 'NONE') {
            res.familyDossier = null;
         } else {
            this.translate.get('SUBJECTS.FAMILY_DOSSIER.' + res.familyDossier).subscribe((result: string) => {
               this.familyDossier = result;
            });
         }

         if (res.familyType === 'NONE') {
            res.familyType = null;
         } else {
            this.translate.get('SUBJECTS.FAMILY_TYPE.' + res.familyType).subscribe((result: string) => {
               this.familyType = result;
            });
         }

         this.isArchived = res.cpsuStatus === 'PASIVE';
         this.isArchivedInCsr = res.csrStatus === 'ПАСИВАН';
      });
      this.cpsuSubjectService.getCpsuFosterFamily(cpsuId).subscribe(res => {
         this.fosterFamilyData = res;
      });
   }

   formatDate(date: string) {
      const [y, m, d] = date.split('-');

      return [d, m, y].join('.');
   }

   editSubject() {
      this.isEditMode = true;
   }

   getNationalities() {
      this.nationality = this.translatorService.translateNationalities();
      this.translate.onLangChange.subscribe(() => {
         this.nationality = [];
         this.nationality = this.translatorService.translateNationalities();
      });
   }

   openDialog(action: 'archive' | 'unarchive' | 'rightsHistory', obj: any) {
      this.object.subject = obj;
      this.object.action = action;
      this.object.subjectFullName = this.subject.firstName + ' ' + this.subject.lastName;

      if (action === DialogActions.ARCHIVE) {
         this.cpsuCaseService.checkActiveRightsForArchive(this.cpsuId).subscribe(
            res => {
               const errorMessages: { [key: string]: { message: string; title: string } } = {
                  SOCIAL_CASE_1: { message: 'ARCHIVE_SUBJECT.SUBJECT_HAS_ACTIVE_CASE', title: 'ARCHIVE_SUBJECT.ARCHIVE_IMPOSIBLE' },
                  SOCIAL_CASE_2: { message: 'ARCHIVE_SUBJECT.SUBJECT_HAS_UNASSIGNED_CASES', title: 'ARCHIVE_SUBJECT.ARCHIVE_IMPOSIBLE' },
               };
               if (res === 'NO_ACTIVE_CASE') {
                  this.openArchiveComponent();
               } else if (errorMessages[res]) {
                  this.toastr.error(errorMessages[res].message, errorMessages[res].title);
               }
            },
            error => {
               this.toastr.error('ERROR_OCCURED');
            }
         );
      } else if (action === DialogActions.UNARCHIVE) {
         this.openArchiveComponent();
      }
   }

   openArchiveComponent() {
      const dialogRef = this.dialog.open(ArchiveSubjectComponent, {
         panelClass: 'overlay-panel',
         disableClose: true,
         width: ModalSizeEnum.MINI,
         data: this.object,
      });

      dialogRef.afterClosed().subscribe(result => {
         const { event, data } = result;
         if (event === DialogActions.ARCHIVE || event === DialogActions.UNARCHIVE) {
            this.subject.dateOfModification = formatDate(new Date());
            this.isSubjectHistoryRendered = false;
            this.subject.cpsuStatus = event === DialogActions.ARCHIVE ? 'PASIVE' : 'ACTIVE';
            if (event === DialogActions.ARCHIVE) {
               this.isArchived = true;
               this.toastr.success('SNACKBAR.SUBJECT_ARCHIVED');
               this.dataSharingService.subjectStatusChange.next(true);
            } else {
               this.isArchived = false;
               this.toastr.success('SNACKBAR.SUBJECT_RETURNED_FROM_ARCHIVE');
               this.dataSharingService.subjectStatusChange.next(false);
            }
         } else if (event !== 'Cancel') {
            this.toastr.error('SNACKBAR.SUBJECT_NOT_ARCHIVED');
         }
      });
   }
}
